import _ from "lodash";
import { TemplateList } from "schema/TemplateSchema.react";
import { REHYDRATE } from "redux-persist/constants";
import {
    FETCH_DECK,
    FETCH_IMAGE,
    UPDATE_ATTEMPT,
    RESET_DECK_ATTEMPT,
} from "backend/storage/mobile/mobile.actions";
import {
    FETCH_DECK_OFFLINE,
    FETCH_ASSESSMENT_OFFLINE,
} from "backend/storage/mobile/mobile.actions";
import { defaultImages } from "config/app.helpers";

const initialDeckAttemptState = {
    id: "",
    courseId: "",
    readerType: "",
    name: "",
    backgroundImage: "",
    presenter: "",
    feedback: true,
    navEnabled: true,
    jumpAhead: false,
    colors: {},
    content: [],
    slideCount: 0,
    passingPercentage: null,
    sessionId: "",
    attemptTime: "",
    viewedSlides: [],
    viewedPercentage: 0,
    lastSlide: 0,
    score: 0,
    questionsTotal: 0,
    questionsAttempted: 0,
    questionsCorrect: 0,
    timeSpent: 0,
    aggregated: true,
    completion: false,
    isFinalExam: false,
    isTopicTest: false,
    snEnabled: true,
};

const updateAttempt = (state, action) => {
    let viewedSlides,
        lastSlide,
        timeSpent,
        viewedPercentage,
        questionsAttempted,
        questionsCorrect,
        score;

    switch (state.readerType) {
        case "qdf":
        case "survey":
            viewedSlides = [...state.viewedSlides, action.data.currentSlide];
            lastSlide = action.data.nextSlide;
            timeSpent = state.timeSpent + action.data.timeSpent;
            viewedPercentage = Math.min(
                100,
                Math.round(
                    (_.uniq(viewedSlides).length * 100) / state.content.length
                )
            );
            questionsAttempted = 0;
            questionsCorrect = 0;
            score = null;
            break;
        case "quiz":
        case "assessment":
        case "casestudy":
            viewedSlides = [...state.viewedSlides, action.data.nextSlide];
            lastSlide = action.data.nextSlide;
            timeSpent = state.timeSpent + action.data.timeSpent;
            viewedPercentage = Math.min(
                100,
                Math.round(
                    (_.uniq(viewedSlides).length * 100) / state.content.length
                )
            );
            questionsAttempted =
                action.data.incrementScore === null
                    ? state.questionsAttempted
                    : state.questionsAttempted + 1;
            questionsCorrect =
                action.data.incrementScore === true
                    ? state.questionsCorrect + 1
                    : state.questionsCorrect;
            score = Math.round((questionsCorrect * 100) / state.questionsTotal);
            break;
        case "videck":
            viewedSlides = [];
            lastSlide = null;
            timeSpent = state.timeSpent + action.data.timeSpent;
            viewedPercentage = action.data.completion;
            questionsAttempted = 0;
            questionsCorrect = 0;
            score = null;
            break;
        case "docdeck":
            viewedSlides = [...state.viewedSlides, action.data.nextSlide];
            lastSlide = action.data.nextSlide;
            timeSpent = state.timeSpent + action.data.timeSpent;
            viewedPercentage = action.data.completion;
            questionsAttempted = 0;
            questionsCorrect = 0;
            score = null;
            break;
        case "game":
        case "dialogue":
        case "scormdeck":
            viewedSlides = [];
            lastSlide = null;
            timeSpent = state.timeSpent + action.data.timeSpent;
            viewedPercentage = action.data.response;
            questionsAttempted = 0;
            questionsCorrect = 0;
            score = action.data.completion ? 100 : 0;
            break;
        case "certdeck":
            viewedSlides = [];
            lastSlide = null;
            timeSpent = null;
            viewedPercentage = 100;
            questionsAttempted = 0;
            questionsCorrect = 0;
            score = null;
            break;
        default:
    }

    return {
        viewedSlides: viewedSlides,
        lastSlide: lastSlide,
        viewedPercentage: viewedPercentage,
        score: score,
        questionsCorrect: questionsCorrect,
        questionsAttempted: questionsAttempted,
        timeSpent: timeSpent,
    };
};

const DeckAttemptReducer = (state = initialDeckAttemptState, action) => {
    switch (action.type) {
        /* istanbul ignore next - react-persist function */
        case REHYDRATE:
            let deckAttempt = action.payload.deckAttempt;
            if (deckAttempt) {
                return { ...state, ...deckAttempt };
            } else {
                return state;
            }
        case FETCH_DECK:
            /* istanbul ignore next - basic fetching state returned */
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
                /* istanbul ignore next - basic success state returned */
            } else if (action.status === "success") {
                return Object.assign({}, action.data.deck, {
                    sessionId: action.data.sessionId,
                    courseId: action.data.deck.courseId,
                    viewedSlides: [],
                    slideCount:
                        action.data.deck.content === undefined
                            ? 0
                            : action.data.deck.content.length,
                    lastSlide: 0,
                    viewedPercentage: 0,
                    score: 0,
                    questionsTotal:
                        ["caseStudy", "assessment", "quiz"].indexOf(
                            action.data.deck.readerType
                        ) !== -1
                            ? _.filter(action.data.deck.content, (slide) => {
                                  return TemplateList[slide.template].scorable;
                              }).length
                            : 0,
                    questionsCorrect: 0,
                    questionsAttempted: 0,
                    attemptTime: action.data.attemptTime,
                    timeSpent: 0,
                    passingPercentage: action.data.deck.passingPercentage,
                    images:
                        /* istanbul ignore next - add imageLibrary if not sent by server */
                        action.data.deck.images === undefined
                            ? defaultImages
                            : action.data.deck.images,
                    aggregated: false,
                    completion:
                        action.data.completion === undefined
                            ? false
                            : action.data.completion,
                    isFinalExam:
                        action.data.isFinalExam === undefined
                            ? false
                            : action.data.isFinalExam,
                    isTopicTest:
                        action.data.isTopicTest === undefined
                            ? false
                            : action.data.isTopicTest,
                });
                /* istanbul ignore next - basic error state returned */
            } else {
                return { ...state, error: action.err };
            }
        case FETCH_DECK_OFFLINE:
            console.log(action);
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return Object.assign({}, action.data, {
                    //   sessionId: action.data.sessionId,
                    courseId: action.data.courseId,
                    viewedSlides: [],
                    slideCount: action.data.content.length,
                    lastSlide: 0,
                    viewedPercentage: 0,
                    score: 0,
                    questionsTotal:
                        ["caseStudy", "assessment", "quiz"].indexOf(
                            action.data.readerType
                        ) !== -1
                            ? _.filter(action.data.content, (slide) => {
                                  return TemplateList[slide.template].scorable;
                              }).length
                            : 0,
                    questionsCorrect: 0,
                    questionsAttempted: 0,
                    attemptTime: action.data.attemptTime,
                    timeSpent: 0,
                    passingPercentage: action.data.passingPercentage,
                    images:
                        /* istanbul ignore next - add imageLibrary if not sent by server */
                        action.data.images === undefined
                            ? defaultImages
                            : action.data.images,
                    aggregated: false,
                    completion:
                        action.data.completion === undefined
                            ? false
                            : action.data.completion,
                    isFinalExam:
                        action.data.isFinalExam === undefined
                            ? false
                            : action.data.isFinalExam,
                    isTopicTest:
                        action.data.isTopicTest === undefined
                            ? false
                            : action.data.isTopicTest,
                });
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case FETCH_ASSESSMENT_OFFLINE:
            console.log(action);
            if (action.status === "fetching") {
                return { ...state, fetchCompleted: false, error: null };
            } else if (action.status === "success") {
                return Object.assign({}, action.data, {
                    //   sessionId: action.data.sessionId,
                    courseId: action.data.courseId,
                    viewedSlides: [],
                    slideCount: action.data.content.length,
                    lastSlide: 0,
                    viewedPercentage: 0,
                    score: 0,
                    questionsTotal:
                        ["caseStudy", "assessment", "quiz"].indexOf(
                            action.data.readerType
                        ) !== -1
                            ? _.filter(action.data.content, (slide) => {
                                  return TemplateList[slide.template].scorable;
                              }).length
                            : 0,
                    questionsCorrect: 0,
                    questionsAttempted: 0,
                    attemptTime: action.data.attemptTime,
                    timeSpent: 0,
                    passingPercentage: action.data.passingPercentage,
                    images:
                        /* istanbul ignore next - add imageLibrary if not sent by server */
                        action.data.images === undefined
                            ? defaultImages
                            : action.data.images,
                    aggregated: false,
                    completion:
                        action.data.completion === undefined
                            ? false
                            : action.data.completion,
                    isFinalExam:
                        action.data.isFinalExam === undefined
                            ? false
                            : action.data.isFinalExam,
                    isTopicTest:
                        action.data.isTopicTest === undefined
                            ? false
                            : action.data.isTopicTest,
                });
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case FETCH_IMAGE:
            if (action.status === "success") {
                let newimages = state.images;
                let imgIndex = newimages.findIndex(
                    (img) => img.id === action.data.id
                );
                if (imgIndex >= 0) {
                    newimages[imgIndex].image = action.data.image;
                    return Object.assign({}, state, {
                        images: newimages,
                    });
                } else {
                    return Object.assign({}, state, {
                        images: [...state.images, action.data],
                    });
                }
            } else {
                return { ...state, error: action.err, fetchCompleted: true };
            }
        case UPDATE_ATTEMPT:
            return Object.assign({}, state, updateAttempt(state, action));
        case RESET_DECK_ATTEMPT:
            return Object.assign({}, state, { aggregated: true });
        default:
            return state;
    }
};

export { DeckAttemptReducer };
